import React from 'react';
import PropTypes from 'prop-types'
import UserAvatar from "../../Atoms/Templates/UserAvatar";
import Badge from "../../Atoms/Badge";
import {fullName} from "../../../helpers/string-format";

const Employee = ({employee}) => {
  return (
    <article className="flex s-mb-0 nowrap">
      <UserAvatar picture={employee.picture} className="s-mr-8px"/>
      <div>
        <p className="small s-mb-0">{fullName(employee)}</p>
        <div className="s-cross-center smaller s-color-light-text">
          <p className="s-mb-0 s-mr-8px">{employee.identification_number} - Design</p>
          <Badge text="Vacaciones"/>
        </div>
      </div>
    </article>
  );
};

Employee.propTypes = {
  employee : PropTypes.shape({
    first_name: PropTypes.string,
    last_name : PropTypes.string,
    identification_number: PropTypes.string,
    picture: PropTypes.string,
  }).isRequired,
}

export default Employee;
